import React from "react";
import DynamicForm from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { useTranslation } from "react-i18next";
import { ISetNewPassword } from "../types.d"
import { Title } from "../util/Title";
import { useGenerateSetPasswordForm } from "./useGenerateSetPasswordForm";
import { useSetPasswordView } from "./useSetPasswordView";

interface IGenerateLoginView {
  password:string;
  username:string;
}

export function SetPasswordView ({ username , password  }: IGenerateLoginView) {
  const { setPassword, isLoading} = useSetPasswordView(password);
  const { formRows  } = useGenerateSetPasswordForm();
  const { t } = useTranslation();
  return (
    <>
      <Title title={t("forms.newPassword.Texts.title")}/>
      <DynamicForm
        formData={{}}
        formRows={formRows}
        spacing="1.5rem"
        formKeyName="test form"
        onHandleSubmit={(data) =>setPassword({...data , username:username, oldPassword:password} as ISetNewPassword)}
        useFormOptions={{
          mode: "onBlur",
          reValidateMode: "onChange",
        }}
        formButtons={{
          leftButton: {
            type: "submit",
            label: t("forms.resetPassword.submit"),
            color: EColourPanel.PRIMARY,
            fullWidth: true,
            disabled: isLoading,
          },
        }}
      />
    </>
  );
};
